import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import Sidebar from "../../../../../partials/aside/Sidebar";
import httpService from "../../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../../helpers/spinner";
import helperNumber from "../../../../../../helpers/numbers";
import helperTime from "../../../../../../helpers/time";

export default function AddCampaign() {
  const [categoriesBannerAlternative, setCategoriesBannerAlternative] =
    useState();

  const [categoryBannerAlternative, setCategoryBannerAlternative] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [countDays, setCountDays] = useState();
  const history = useHistory();

  useEffect(() => {
    getCategoriesBannerAlternative();
  }, []);

  useEffect(() => {
    if (!categoryBannerAlternative) {
      return;
    }
    setStartDate(categoryBannerAlternative.start_date);
    setEndDate(categoryBannerAlternative.end_date);
    setCountDays(
      moment(categoryBannerAlternative.end_date).diff(
        categoryBannerAlternative.start_date,
        "days"
      ) + 1
    );
  }, [categoryBannerAlternative]);

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getCategoriesBannerAlternative = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const categoriesBannerAlternative =
      await sendRequestGetCategoriesBannerAlternative();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!categoriesBannerAlternative) {
      return;
    }
    setCategoriesBannerAlternative(categoriesBannerAlternative);
  };

  const sendRequestGetCategoriesBannerAlternative = async () => {
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/category-user-site-publishers/add-campaign/4",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return categoryAllPublisher.data.data;
  };

  const generateTagCategoriesBannerAlternative = () => {
    return categoriesBannerAlternative.map((categoryBannerAlternative) => {
      return (
        <option value={categoryBannerAlternative.id}>
          {categoryBannerAlternative.name}
        </option>
      );
    });
  };

  const selectCategorySitePublisher = async (categoryID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const categorySitePublisherAlternative =
      await sendRequestGetCategorySitePublisherData(categoryID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!categorySitePublisherAlternative) {
      return;
    }
    setCategoryBannerAlternative(categorySitePublisherAlternative);
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForm = getDataForm();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddBannerAlternative =
      await sendRequestAddBannerAlternative(dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestAddBannerAlternative) {
      return;
    }
    history.push("/campaigns/manage/banner-alternative/all");
  };

  const getDataForm = () => {
    return {
      priority: document.querySelector("#priority").value + "",
      category_id: categoryBannerAlternative.id + "",
      name: document.querySelector("#name-campaign").value.trim(),
    };
  };

  const sendRequestAddBannerAlternative = async (dataForm) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/manage/banner/alternative",
        dataForm,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return true;
  };

  const sendRequestGetCategorySitePublisherData = async (categoryID) => {
    const headersRequest = getHeaderForRequest();
    let categorySitePublisherData;
    try {
      categorySitePublisherData = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/category-user-site-publishers/" +
          categoryID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return categorySitePublisherData.data.data;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  اضافه کردن کمپین های جایگزین بنری
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div id="add-campaign-user">
                <form onSubmit={sendForm}>
                  <div className="col-12 col-md-6  ">
                    <label>نام کمپین</label>
                    <input
                      className="form-control"
                      id="name-campaign"
                      type="text"
                      required
                    />
                  </div>

                  <div className="col-12 col-md-6 py-4">
                    <label className="pl-1">
                      اولویت نمایش (عدد وارد کنید,عدد کوچکتر اولویت بیشتر دارد.)
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      id="priority"
                      required
                    />
                  </div>

                  <div className="col-12 col-md-6 pb-4 ">
                    <label>گروه سایت های نمایش دهنده بنری</label>
                    <select
                      id="category-campaign"
                      className="form-control"
                      onChange={(e) => {
                        const categoryID = parseInt(e.target.value);
                        if (!categoryID) {
                          return;
                        }
                        selectCategorySitePublisher(categoryID);
                      }}
                    >
                      <option value="0">انتخاب کنید</option>
                      {categoriesBannerAlternative &&
                        generateTagCategoriesBannerAlternative()}
                    </select>
                  </div>

                  <div className="alert alert-primary ">
                    <div className="col-12 col-md-6 pt-2 ">
                      <span>
                        <label className="pl-1">تاریخ شروع : </label>
                      </span>
                      <span className="number-finance">
                        <label className="pr-2">
                          {startDate && (
                            <>
                              {helperNumber.toPersianNum("00:00") +
                                "   " +
                                helperNumber.toPersianNum(
                                  helperTime.convertGregorianToJalali(startDate)
                                )}
                            </>
                          )}
                        </label>
                      </span>
                    </div>

                    <div className="col-12 col-md-6 pt-2 ">
                      <span>
                        <label className="pl-1">تاریخ پایان : </label>
                      </span>
                      <span className="number-finance">
                        <label className="pr-2">
                          {endDate && (
                            <>
                              {helperNumber.toPersianNum("23:59") +
                                "   " +
                                helperNumber.toPersianNum(
                                  helperTime.convertGregorianToJalali(endDate)
                                )}
                            </>
                          )}
                        </label>
                      </span>
                    </div>

                    <div className="col-12 col-md-6 pt-2 ">
                      <span>
                        <label className="pl-1">تعداد شبانه روز کمپین : </label>
                      </span>
                      <span>
                        {countDays && (
                          <>
                            <label className="number-finance">
                              {helperNumber.toPersianNum(countDays)}
                            </label>
                            <label className="pr-2">شبانه روز</label>
                          </>
                        )}
                      </span>
                    </div>
                  </div>

                  <div className="col-12 col-md-6 pt-2 ">
                    <button type="submit" className="btn btn-primary">
                      درج کمپین
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
